import { render } from "./DashboardMTI.vue?vue&type=template&id=73d63fb4"
import script from "./DashboardMTI.vue?vue&type=script&lang=js"
export * from "./DashboardMTI.vue?vue&type=script&lang=js"

import "./DashboardMTI.vue?vue&type=style&index=0&id=73d63fb4&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__